// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"DiscountsEdit_pageHeader__nn1rG DiscountsList_pageHeader__37Efx","datePickerWrapper":"DiscountsEdit_datePickerWrapper__3N9Rt"};